import React, { JSX } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material";
import "./customButtonStyles.scss";
import CustomBtnSpinner from "./CustomBtnSpinnerI";
import buttonVariantsType from "../../constants/buttonVariantsType";


export interface CustomButtonI {
  onClick?: (
    event?: React.MouseEvent<HTMLButtonElement, MouseEvent> | any,
    id?: string
  ) => void;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  children?: JSX.Element | JSX.Element[] | string;
  buttonColor?: buttonVariantsType;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  sx?: SxProps<Theme>;
  truncate?: boolean;
}

const CustomButton = ({
  sx,
  onClick,
  disabled = false,
  startIcon,
  endIcon,
  children,
  type,
  buttonColor = "buttonStylePrimary",
  loading = false,
  truncate = false,
}: CustomButtonI) => {
  return (
    <Button
      type={type}
      sx={{ pointerEvents: loading ? "none" : "auto", ...sx }}
      className={`Button ${buttonColor}`}
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {loading ? (
        <CustomBtnSpinner />
      ) : (
        <Box
          sx={
            truncate
              ? {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }
              : {}
          }
        >
          {children}
        </Box>
      )}
    </Button>
  );
};

export default CustomButton;